import React from 'react'
import Anchor from './Anchor/Anchor'
import Hint from './Hint/Hint'
import Tabs from './Tabs/Tabs'
import { css } from '@emotion/react'
import ImportMD from './ImportMD/ImportMD'
import YoutubeEmbed from './YouTubeEmbed/YoutubeEmbed'
import CodeBlock from './CodeBlock/codeBlock'
import Exercise from './Exercise/Exercise'

const HeadingStyle = css`

  line-height: 1.5;
  margin-top: 1.6em;
  margin-bottom: .8em;
  transition: background-color 0.8s ease;
  position: relative;
  &:before{
    transition: all 0.8s ease;
    opacity: 0;
    content: '➤';
    position: absolute;
    left: -25px;
  }
  &.scrolledTo{
    background-color: #FFE000;
    border-radius: 3px;
    &:before{
      opacity: 1;
    }
  }
`

const TableScrollStyle = css`

  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  word-break: keep-all;

`

const titleToId = ({ children }) =>{

  if(typeof children != "string") return null

  return children
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[åä]/g, 'a')
    .replace(/ö/g, 'o')
}


export default {
  h1: props => <h1 css={HeadingStyle} id={titleToId(props)} {...props} />,
  h2: props => <h2 css={HeadingStyle} id={titleToId(props)} {...props} />,
  h3: props => <h3 css={HeadingStyle} id={titleToId(props)} {...props} />,
  h4: props => <h4 css={HeadingStyle} id={titleToId(props)} {...props} />,
  h5: props => <h5 css={HeadingStyle} id={titleToId(props)} {...props} />,
  h6: props => <h6 css={HeadingStyle} id={titleToId(props)} {...props} />,
  p: props => <p {...props} />,
  pre: props => <>{props.children}</>,
  code: CodeBlock,
  inlineCode: props => <code className={'inline-code'}>{props.children}</code>,
  a: props => <Anchor {...props} />,
  table: props => <div css={TableScrollStyle}><table>{props.children}</table></div>,  
  Hint,
  Tabs,
  ImportMD,
  Youtube: YoutubeEmbed,
  YouTube: YoutubeEmbed,
  Exercise
}
